import React from 'react';
import styled from 'styled-components';
import SVG, {Props as SVGProps} from 'react-inlinesvg';
import {transformSizePropToSize} from '../../utils/common';
import {BaseIconContainer} from './styled';

import questionCircle from '../../assets/icons/icon-question-circle.svg';
import whiteArrowRight from '../../assets/icons/arrowNext.svg';
import trash from '../../assets/icons/rubbish-bin.svg';
import camera from '../../assets/icons/camera.svg';
import picture from '../../assets/icons/picture-icon.svg';
import close from '../../assets/icons/close-icon.svg';
import padlock from '../../assets/icons/padlock.svg';
import backArrow from '../../assets/icons/back-arrow.svg';
import arrowRightBlue from '../../assets/icons/arrow-right-icon-blue.svg';
import thunder from '../../assets/icons/tunder_icon.svg';
import editIcon from '../../assets/icons/edit-icon.svg';
import questionCircleBlue from '../../assets/icons/question-icon.svg';
import warningSecondary from '../../assets/icons/warning-secondary.svg';
import checkSecondary from '../../assets/icons/check-secondary.svg';
import creditCardBlue from '../../assets/icons/credit-card-blue2.svg';
import checkOutCalendar from '../../assets/icons/check-out-calendar.svg';
import checkInCalendar from '../../assets/icons/check-in-calendar.svg';
import multiGuest from '../../assets/icons/multi-guest.svg';
import backBlueArrow from '../../assets/icons/back-blue-arrow.svg';
import information from '../../assets/icons/information.svg';
import plusBlueIcon from 'assets/icons/plus-blue-icon.svg';
import languageIcon from 'assets/icons/language-icon.svg';
import lockIcon from 'assets/icons/lock-icon.svg';
import homeSidebar from 'assets/icons/home-sidebar.svg';
import keySidebar from 'assets/icons/key-sidebar.svg';
import languageSidebar from 'assets/icons/language-sidebar.svg';
import locationSidebar from 'assets/icons/location-sidebar.svg';
import lockSidebar from 'assets/icons/lock-sidebar.svg';
import faqSidebar from 'assets/icons/faq-sidebar.svg';
import onlineChekinSidebar from 'assets/icons/online-chekin-sidebar.svg';
import checkFill from 'assets/icons/check-fill.svg';
import shoppingCart from 'assets/icons/shopping-cart.svg';
import blackMenuIcon from 'assets/icons/black-menu-icon.svg';
import closeIcon from 'assets/icons/close-black-icon.svg';
import allianzShieldIcon from 'assets/icons/allianz-shield-icon.svg';
import checkedBlack from 'assets/icons/checked.svg';
import informationGray from 'assets/icons/information-gray.svg';
import allianzBlockShieldIcon from 'assets/icons/allianz-block-shield-icon.svg';
import helpBlueIcon from 'assets/icons/help-icon.svg';
import threeDots from '../../assets/icons/three-dots.svg';
import allianzLogoMini from 'assets/icons/allianz-logo-mini.svg';
import allianzCwdIcon from '../../assets/icons/allianz-cwd-icon.svg';
import insuranceCwdIcon from '../../assets/icons/insurance-cwd.svg';
import insuranceCwdSmallIcon from '../../assets/icons/insurance-cwd-small.svg';
import remoteAccessBuilding from '../../assets/icons/remote-access-building.svg';
import remoteAccessApartment from '../../assets/icons/remote-access-apartment.svg';
import doubleArrow from '../../assets/icons/double-arrow.svg';
import warningErrorIcon from '../../assets/icons/warning-error-icon.svg';
import checkboxIcon from 'assets/icons/checkbox.svg';

export type IconNames =
  | 'questionCircle'
  | 'whiteArrowRight'
  | 'trash'
  | 'camera'
  | 'picture'
  | 'close'
  | 'padlock'
  | 'backArrow'
  | 'arrowRightBlue'
  | 'editIcon'
  | 'thunder'
  | 'questionCircleBlue'
  | 'warningSecondary'
  | 'checkSecondary'
  | 'creditCardBlue'
  | 'checkOutCalendar'
  | 'checkInCalendar'
  | 'multiGuest'
  | 'backBlueArrow'
  | 'plusBlueIcon'
  | 'information'
  | 'languageIcon'
  | 'lockIcon'
  | 'homeSidebar'
  | 'keySidebar'
  | 'languageSidebar'
  | 'locationSidebar'
  | 'lockSidebar'
  | 'faqSidebar'
  | 'onlineChekinSidebar'
  | 'checkFill'
  | 'shoppingCart'
  | 'blackMenuIcon'
  | 'closeIcon'
  | 'allianzShieldIcon'
  | 'checkedBlack'
  | 'informationGray'
  | 'allianzBlockShieldIcon'
  | 'helpBlueIcon'
  | 'threeDots'
  | 'allianzLogoMini'
  | 'allianzCwdIcon'
  | 'insuranceCwdIcon'
  | 'insuranceCwdSmallIcon'
  | 'remoteAccessBuilding'
  | 'remoteAccessApartment'
  | 'doubleArrow'
  | 'warningErrorIcon'
  | 'checkboxIcon';

export type IconsHash = {
  [K in IconNames]: string;
};

const icons: IconsHash = {
  questionCircle,
  whiteArrowRight,
  trash,
  camera,
  picture,
  close,
  padlock,
  backArrow,
  arrowRightBlue,
  editIcon,
  thunder,
  questionCircleBlue,
  warningSecondary,
  checkSecondary,
  creditCardBlue,
  checkOutCalendar,
  checkInCalendar,
  multiGuest,
  backBlueArrow,
  information,
  plusBlueIcon,
  languageIcon,
  lockIcon,
  homeSidebar,
  keySidebar,
  languageSidebar,
  locationSidebar,
  lockSidebar,
  faqSidebar,
  onlineChekinSidebar,
  checkFill,
  shoppingCart,
  blackMenuIcon,
  closeIcon,
  allianzShieldIcon,
  checkedBlack,
  informationGray,
  allianzBlockShieldIcon,
  helpBlueIcon,
  threeDots,
  allianzLogoMini,
  allianzCwdIcon,
  insuranceCwdIcon,
  insuranceCwdSmallIcon,
  remoteAccessBuilding,
  remoteAccessApartment,
  doubleArrow,
  warningErrorIcon,
  checkboxIcon,
};

export type IconProps = {
  name: IconNames;
  title?: string;
  className?: string;
  size?: string | number;
  color?: string;
} & React.HTMLAttributes<SVGElement> &
  React.HTMLAttributes<SVGProps>;

const StyledSVGIcon = styled(SVG)<{
  src: any;
  color?: string;
  size?: string | number;
}>`
  width: ${props => transformSizePropToSize(props.size) || '24px'};
  height: ${props => transformSizePropToSize(props.size) || '24px'};
  fill: ${props => props.color || 'none'};
  color: ${props => props.color || 'none'};

  path {
    fill: ${props => props.color || 'currentColor'};
  }
`;

const CustomIcon = (props: IconProps) => {
  return (
    <BaseIconContainer size={props.size} className="custom-icon">
      <StyledSVGIcon
        src={icons[props.name]}
        size={props.size}
        width={props.size}
        height={props.size}
        title={props.title || props.name}
        color={props.color || 'transparent'}
        className={'custom-icon__icon ' + props.className}
      />
    </BaseIconContainer>
  );
};

export {CustomIcon};
